module.exports = __webpack_public_path__ + "static/media/produto-3.20bb541d.png";